import React from 'react';
import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { useSearchFieldStates } from '../hooks/useSearchFieldStates';

import { BasicInfo, GeneralTab, OtherTab } from './tabs';
import { initialValues, searchSchema } from '../schema';
import { formatDateToYYYYMMDD } from '../utils';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: BanHangPayload) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const searchFieldStates = useSearchFieldStates();

  const handleSubmit = async (data: BanHangPayload) => {
    const searchFieldData = searchFieldStates.getSearchFieldData();

    const combinedData = {
      ...data,
      ...searchFieldData,
      ngay_ct1: formatDateToYYYYMMDD(data.ngay_ct1),
      ngay_ct2: formatDateToYYYYMMDD(data.ngay_ct2),
      ma_lvt: data.ma_lvt || '',
      data_analysis_struct: data.data_analysis_struct === 'no_analysis' ? '' : data.data_analysis_struct
    };
    onSearch(combinedData);
    onClose();
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Bảng kê hàng bán bị trả lại'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto' style={{ width: '800px', minWidth: '800px' }}>
            <BasicInfo />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'general',
                  label: 'Thông tin chung',
                  component: <GeneralTab searchFieldStates={searchFieldStates} />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab searchFieldStates={searchFieldStates} />
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
